const deviceName = () => {
    let device = '';
    const orgUrl = localStorage.getItem('org_url') || '';
    const href = window.location.href;
    if (href.indexOf('view=web') !== -1 || orgUrl.indexOf('view=web') !== -1) {
        device = 'desktop'
    } else if (href.indexOf('appversionios') !== -1 || orgUrl.indexOf('appversionios') !== -1) {
        device = 'iosapp'
    } else if (href.indexOf('appversionandroid') !== -1 || orgUrl.indexOf('appversionandroid') !== -1) {
        device = 'androidapp'
    } else {
        device = 'pwa'
    }
    return device;
};

class CleverTapSdk {
    handleEventtracking(eventData, eventName = "Photo Booth") {
        let device = deviceName();
        let user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            eventData['userid'] = user.userid
        }
        eventData['Date'] = new Date();
        eventData['device'] = device;
        console.log("eventName", eventName);
        console.log("eventData", eventData);
        if (window.clevertap) {
            console.log(window.clevertap.event.push(eventName, eventData));
        } else {
            setTimeout(function () {
                new CleverTapSdk().handleEventtracking(eventData, eventName);
            }, 100)
        }
    }
}

export default new CleverTapSdk();
